import { render } from "./PartnersView.vue?vue&type=template&id=214c0531&scoped=true"
import script from "./PartnersView.vue?vue&type=script&lang=js"
export * from "./PartnersView.vue?vue&type=script&lang=js"

import "./PartnersView.vue?vue&type=style&index=0&id=214c0531&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-214c0531"]])

export default __exports__